// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> repli-sandbox-preferred-preferred -> redwood-ypsilanti-apartments
// Generated: 2026-10-05T19:01:15.208Z
// Counts: 1 design, 52 content, 4 slot group, 4 collection binding, 4 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[0].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[0].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "gallery.images": {
    "limit": 20,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      0
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 6
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
